import { render, staticRenderFns } from "./flickthrough.vue?vue&type=template&id=c89ce2bc"
import script from "./flickthrough.vue?vue&type=script&lang=js"
export * from "./flickthrough.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports